const { EventEmitter } = require('./lib/event-emitter');
const { Timer } = require('./lib/timer');

module.exports = {
  EventEmitter,
  Timer,
};
